<template>
    <div>
        <!-- 底部开始 -->
        <footer>
            <div class="footerwrap clearfix marT">
                <div class="footer-btn clearfix">
                	<!--<p class="gray">艾克斯珀展览展示（天津）有限公司</p>
                    <p class="gray margTop">津ICP备18002498号</p>-->
                    <p class="gray">团车互联网信息服务（北京）有限公司杭州分公司</p>
                    <p class="gray margTop">京ICP备12044574号-2</p>      
                </div>
            </div>
        </footer>
        <div class="topBack"></div>
    </div>
</template>
<style scoped lang="less">
@import "../../../assets/less/common.less";
	/*底部开始*/
.footerwrap{
    text-align: center;
    /*padding-top:0.352632rem;*/
    background-color:#1b1880;
    .size{
          color:#666;
          .px2px(font-size, 24px);
            padding:0 0.2rem;
          .redsize{
            color:#ff7c7c;
          }

    }

    .footer-tel{
         .px2px(font-size, 24px);
        color:#a6a6a6;
        text-align: center;
        position: relative;
        span{
            display: block;
            margin-top: 0.266667rem;
            a{
              color:#a6a6a6;
            }
        }
        .marT{
		    margin-top: 30px;
		}
    }

    .footer-btn{
        .px2px(font-size, 20px);
        margin:0.394737rem 0 0.578947rem 0;
        color:#fff;
       	.margTop{
       		margin-top: 10px;
       	}
    }
    
}
.topBack{
    display: none;
    position: fixed;
    bottom:0.8rem;
    right:0.563158rem;
    width: 1.289474rem;
    height:1.289474rem;
    background-size:100% 100%;
    z-index: 4;
}
	
</style>
<script>
export default {
    name: 'carExpofooterComponent',
    data:function() {
        return {
        }
    },
    mounted:function(){
    }
}
</script>



// WEBPACK FOOTER //
// src/components/global/carExpofooter/carExpofooter.vue